<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Werbemittel bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.banners.update', banner))">
                <form-fields :form="form" :banner="banner" :zones="zones" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'banner',
            'zones',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.banner.name,
                    description: this.banner.description,
                    js_code: this.banner.js_code,
                    css_code: this.banner.css_code,
                    html_code: this.banner.html_code,
                    zones: this.banner.zones,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>